'use client';

import { Portal } from '@common/components';
import { cn } from '@core/utils';
import type { ReactNode } from 'react';

import { useBottomCTAAnimation } from './useBottomCTAAnimation';

export interface CartBottomCTADesktopProps {
  children: ReactNode;
  toastContent?: ReactNode;
  isHidden?: boolean;
  className?: string;
}

export const CartBottomCTADesktop = ({
  children,
  toastContent,
  isHidden = false,
  className,
}: CartBottomCTADesktopProps) => {
  const { isBottomVisible, isToastActive, displayToastContent } =
    useBottomCTAAnimation({ isHidden, toastContent });

  return (
    <Portal>
      <div
        className={cn(
          'fixed inset-x-0 bottom-0 z-20 mx-auto flex w-full max-w-screen-xl flex-col items-center px-20 pb-20 transition-transform duration-300 ease-out',
          isBottomVisible ? 'translate-y-0' : 'translate-y-full',
          className,
        )}
      >
        {/* 혜택 토스트 - pill 형태 뱃지 */}
        <div
          className={cn(
            'mb-8 rounded-pill bg-Gray-black px-20 py-12 shadow-[0px_0px_8px_0px_rgba(0,0,0,0.04),0px_8px_10px_0px_rgba(0,0,0,0.05)] transition-all duration-300 ease-out',
            isToastActive
              ? 'translate-y-0 opacity-100'
              : 'translate-y-8 opacity-0',
          )}
        >
          {displayToastContent}
        </div>

        {/* 메인 콘텐츠 */}
        <div className="w-full rounded-xxlarge bg-Gray-white shadow-[0px_10px_15px_0px_rgba(0,0,0,0.06),0px_-2px_12px_0px_rgba(0,0,0,0.03)]">
          {children}
        </div>
      </div>
    </Portal>
  );
};
